var _style, _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 360 412",
    style: {
      enableBackground: "new 0 0 360 412"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{fill:url(#SVGID_5_);}\n\t.st5{fill:url(#SVGID_6_);}\n\t.st6{opacity:0;}\n\t.st7{opacity:0.43;}\n\t.st8{fill:url(#SVGID_7_);}\n\t.st9{fill:url(#SVGID_8_);}\n\t.st10{fill:url(#SVGID_9_);}\n\t.st11{fill:url(#SVGID_10_);}\n\t.st12{fill:url(#SVGID_11_);}\n\t.st13{fill:url(#SVGID_12_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 93.5095,
    y1: -355.918,
    x2: 354.5504,
    y2: -205.2059,
    gradientTransform: "matrix(1 0 0 1 0 410)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002397759,
    style: {
      stopColor: "#B854FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#22A1FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00CCDB"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M356,110.9c0-4.3-2.3-8.2-6-10.4L268,53L186,5.5c-3.7-2.2-8.3-2.2-12,0l-76,44c-2.2,1.3-3.9,3.2-4.9,5.4 c1.7,0.2,3.4,0.7,4.9,1.5l76,44c3.7,2.1,6,6.1,6,10.4V206l82-47.5c3.7-2.2,8.3-2.2,12,0l76,44c1.5,0.9,2.8,2.1,3.8,3.5 c1.4-2,2.2-4.4,2.2-6.9V110.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 93.5311,
    y1: -52.1445,
    x2: 354.5721,
    y2: -202.8566,
    gradientTransform: "matrix(1 0 0 1 0 410)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002252811,
    style: {
      stopColor: "#D7E200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    style: {
      stopColor: "#33CE00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00DBD0"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M350,209.5l-76,44c-3.7,2.2-8.3,2.2-12,0L180,206v95.1c0,4.3-2.3,8.2-6,10.4l-76,44c-1.5,0.9-3.2,1.4-4.9,1.5 c1,2.2,2.7,4.1,4.9,5.4l76,44c3.7,2.2,8.3,2.2,12,0l82-47.5l82-47.5c3.7-2.1,6-6.1,6-10.4v-88.2c0-2.5-0.8-4.9-2.2-6.9 C352.8,207.4,351.5,208.6,350,209.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 180.8911,
    y1: -204,
    x2: 350.007,
    y2: -204,
    gradientTransform: "matrix(1 0 0 1 0 410)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002252811,
    style: {
      stopColor: "#00DBA4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00ACDB"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M350,202.5l-76-44c-3.7-2.2-8.3-2.2-12,0L180,206l82,47.5c3.7,2.2,8.3,2.2,12,0l76-44c1.5-0.9,2.8-2.1,3.8-3.5 C352.8,204.6,351.5,203.4,350,202.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 92,
    y1: -52.9156,
    x2: 92,
    y2: -355.1429,
    gradientTransform: "matrix(1 0 0 1 0 410)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F0F000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5271,
    style: {
      stopColor: "#FF3333"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF00FF"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M92,263.9c0-4.3,2.3-8.2,6-10.4l82-47.5l-82-47.5c-3.7-2.1-6-6.1-6-10.4V59.9c0-1.7,0.4-3.4,1.1-5 c-2.4-0.2-4.9,0.3-7.1,1.5l-76,44c-3.7,2.1-6,6.1-6,10.4V206v95.1c0,4.3,2.3,8.2,6,10.4l76,44c2.2,1.3,4.7,1.8,7.1,1.5 c-0.7-1.5-1.1-3.2-1.1-5V263.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 93.0155,
    y1: -354.9512,
    x2: 180.1255,
    y2: -204.0725,
    gradientTransform: "matrix(1 0 0 1 0 410)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0009920635,
    style: {
      stopColor: "#BB00FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF00D4"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M92,148.1c0,4.3,2.3,8.2,6,10.4l82,47.5v-95.1c0-4.3-2.3-8.2-6-10.4l-76-44c-1.5-0.9-3.2-1.4-4.9-1.5 c-0.7,1.5-1.1,3.2-1.1,5V148.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 92.9723,
    y1: -52.9738,
    x2: 180.1255,
    y2: -203.9276,
    gradientTransform: "matrix(1 0 0 1 0 410)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#79E200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9977,
    style: {
      stopColor: "#D7E200"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M174,311.5c3.7-2.1,6-6.1,6-10.4V206l-82,47.5c-3.7,2.1-6,6.1-6,10.4v88.2c0,1.7,0.4,3.4,1.1,5 c1.7-0.2,3.4-0.7,4.9-1.5L174,311.5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.5,152.4l-73-42.3c-0.8-0.5-1.6-0.7-2.5-0.7s-1.7,0.2-2.5,0.7C5.9,111,5,112.6,5,114.4v186.7c0,3.9,2.1,7.6,5.5,9.5 l73,42.3c1.6,0.9,3.4,0.9,5,0s2.5-2.5,2.5-4.3V161.9C91,158,88.9,154.4,85.5,152.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.5,305.4l-73-42.3c-0.8-0.5-1.6-0.7-2.5-0.7s-1.7,0.2-2.5,0.7c-1.6,0.9-2.5,2.5-2.5,4.3v84.7c0,3.9,2.1,7.6,5.5,9.5 l73,42.3c1.6,0.9,3.4,0.9,5,0s2.5-2.5,2.5-4.3v-84.7C179,311,176.9,307.4,173.5,305.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.5,152.4l-73-42.3c-0.8-0.5-1.6-0.7-2.5-0.7s-1.7,0.2-2.5,0.7c-1.6,0.9-2.5,2.5-2.5,4.3v84.7c0,3.9,2.1,7.6,5.5,9.5 l73,42.3c1.6,0.9,3.4,0.9,5,0s2.5-2.5,2.5-4.3v-84.7C267,158,264.9,154.4,261.5,152.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_7_",
    cx: 228.5979,
    cy: -230.9673,
    r: 193.3335,
    gradientTransform: "matrix(1 0 0 1 0 410)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M11,104c0,1.8,0.9,3.4,2.5,4.3l73,42.3c3.4,2,7.6,2,11,0l73-42.3c1.6-0.9,2.5-2.5,2.5-4.3s-0.9-3.4-2.5-4.3 l-73-42.3c-3.4-2-7.6-2-11,0l-73,42.3C11.9,100.6,11,102.2,11,104z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_8_",
    cx: 228.5979,
    cy: -230.9673,
    r: 193.3335,
    gradientTransform: "matrix(1 0 0 1 0 410)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M99,53c0,1.8,0.9,3.4,2.5,4.3l161,93.3c3.4,2,7.6,2,11,0l73-42.3c1.6-0.9,2.5-2.5,2.5-4.3s-0.9-3.4-2.5-4.3 l-161-93.3c-1.7-1-3.6-1.5-5.5-1.5s-3.8,0.5-5.5,1.5l-73,42.3C99.9,49.6,99,51.2,99,53z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_9_",
    cx: 132.4464,
    cy: -173.5109,
    r: 96.5368,
    gradientTransform: "matrix(1 0 0 1 0 410)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M261,257c0-1.8-0.9-3.4-2.5-4.3l-73-42.3c-3.4-2-7.6-2-11,0l-73,42.3c-1.6,0.9-2.5,2.5-2.5,4.3 s0.9,3.4,2.5,4.3l73,42.3c3.4,2,7.6,2,11,0l73-42.3C260.1,260.4,261,258.8,261,257z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_10_",
    cx: 132.4464,
    cy: -275.5253,
    r: 102.3441,
    gradientTransform: "matrix(1 0 0 1 0 410)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002418155,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M176.5,110.1c-0.8-0.5-1.6-0.7-2.5-0.7s-1.7,0.2-2.5,0.7l-73,42.3c-3.4,2-5.5,5.6-5.5,9.5v84.7 c0,1.8,0.9,3.4,2.5,4.3c1.6,0.9,3.4,0.9,5,0l73-42.3c3.4-2,5.5-5.6,5.5-9.5v-84.7C179,112.6,178.1,111,176.5,110.1z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_11_",
    cx: 240.3237,
    cy: -225.1044,
    r: 237.574,
    gradientTransform: "matrix(1 0 0 1 0 410)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002418155,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M352.5,110.1c-0.8-0.5-1.6-0.7-2.5-0.7s-1.7,0.2-2.5,0.7l-73,42.3c-3.4,2-5.5,5.6-5.5,9.5v84.7 c0,1.8,0.9,3.4,2.5,4.3s3.4,0.9,5,0l73-42.3c3.4-2,5.5-5.6,5.5-9.5v-84.7C355,112.6,354.1,111,352.5,110.1z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_12_",
    cx: 240.3237,
    cy: -225.1044,
    r: 237.574,
    gradientTransform: "matrix(1 0 0 1 0 410)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002418155,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M352.5,212.1c-0.8-0.5-1.6-0.7-2.5-0.7s-1.7,0.2-2.5,0.7l-161,93.3c-3.4,2-5.5,5.6-5.5,9.5v84.7 c0,1.8,0.9,3.4,2.5,4.3s3.4,0.9,5,0l161-93.3c3.4-2,5.5-5.6,5.5-9.5v-84.7C355,214.6,354.1,213,352.5,212.1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.fbcd5a91af226da642a6f263c7df7913.svg";
export { ForwardRef as ReactComponent };